<template>
  <div class="container">
    <el-dialog
      :visible.sync="visible"
      title="代发货单"
      center
      width="80%">
      <div class="title-container">
        <span class="title-text">{{$t('common.productOrderNo')}}: {{productOrderNo}}</span>
      </div>
      <el-table
        :data="unAssociatedBoxList"
        style="margin-bottom: 10px;"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        :span-method="objectSpanMethod">
        <el-table-column
          :label="$t('common.number')"
          prop="index"
          width="50">
        </el-table-column>
        <el-table-column prop="prodInfo" label="产品型号"></el-table-column>
        <el-table-column prop="boxNo" :label="$t('common.boxNo')"></el-table-column>
        <el-table-column prop="binLevel" :label="$t('common.binLevel')" width="60"></el-table-column>
        <el-table-column prop="lotNo" :label="$t('common.lotNo')"></el-table-column>
        <el-table-column prop="totale" :label="$t('common.count')" width="60"></el-table-column>
        <el-table-column :label="$t('common.operate')" width="80">
          <template slot-scope="scope">
            <el-button type="text" class="link" @click.stop="addBoxPut(scope.row, scope.$index)">
              {{$t('common.associate')}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-form @submit.native.prevent :inline="true" :model="form" :rules="rules" ref="refForm">
      <el-form-item prop="productOrderNo">
        <el-input
          ref="refProductOrderNo"
          autocomplete="off"
          clearable
          maxlength="64"
          v-model.trim="form.productOrderNo"
          @clear="reset"
          :placeholder="$t('common.productOrderNo')"
          @keyup.enter.native="handleEnterProductOrderNo">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="text" size="medium" @click="query">
          {{$t('common.query')}}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="deliver-order-text">
      代发货单
      <div class="separator"/>
    </div>
    <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto;">
      <li v-for="item in listData" :key="item.id" class="infinite-list-item">
        <tpProdProductOrder :data="item" @click="onClickProductOrder"/>
      </li>
    </ul>
  </div>
</template>

<script>
import { tporderList, addBoxPut, tporderDetail } from '@/api/tpProdOrder';
import { prodOrderList, prodOrderAddBox, prodOrderDetailById } from '@/api/prodOrder';
import { storeStatus } from '@/utils/defines';
import tpProdProductOrder from './tpProdProductOrder';
import {
  validateBoxNo,
} from '@/utils/validate';

export default {
  name: 'AssociatedBox',
  components: {
    tpProdProductOrder,
  },
  data() {
    return {
      form: {
        productOrderNo: undefined,
      },
      rules: {
      },
      page: 1,
      perpage: 20,
      totalCount: 0,
      listData: [],
      visible: false,
      productOrderNo: undefined,
      unAssociatedBoxList: [],
    };
  },
  mounted() {
    this.tporderList();
    this.$refs.refProductOrderNo && this.$refs.refProductOrderNo.focus();
    this.scanBoxInfoBarCode();
  },
  methods: {
    handleEnterProductOrderNo() {
      this.query();
    },
    query() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          this.page = 1;
          this.listData = [];
          this.tporderList();
        }
      });
    },
    reset() {
      this.page = 1;
      this.listData = [];
      this.tporderList();
    },
    async tporderList() {
      try {
        const {
          productOrderNo,
        } = this.form;
        const res = await tporderList({
          page: this.page,
          perpage: this.perpage,
          productOrderNo: productOrderNo || undefined,
          status: storeStatus.received.val,
        });
        const { data } = res;
        if (data.count !== undefined) {
          this.totalCount = data.count;
        }
        if (this.page === 1) {
          this.listData = data.records;
        } else {
          this.listData = this.listData.concat(data.records);
        }
      } catch (e) {
        // do nothing.
      }
    },
    async addBoxPut(row, index) {
      const { productOrderNo } = this;
      const {
        boxNo,
        rowspan,
      } = row;
      try {
        await addBoxPut({ productOrderNo, boxNos: [boxNo] });
        this.$message({
          type: 'success',
          message: this.$t('common.associateSuccess'),
        });
        this.unAssociatedBoxList.splice(index, rowspan);
      } catch (e) {
        // do nothing
      }
    },
    load() {
      if (this.listData.length === 0 || this.listData.length >= this.totalCount) {
        return;
      }
      this.page += 1;
      this.tporderList();
    },
    async onClickProductOrder(data) {
      this.productOrderNo = data.productOrderNo;
      try {
        const res = await tporderDetail({ productOrderNo: this.productOrderNo,result:true });
        const {
          data,
        } = res;
        const {
          detail,
          incoOrderProdStoreParsed
        } = data;
        const {
          binLevelData,
        } = detail;
        this.unAssociatedBoxList = [];
        let info, length, status, prodOrderId, totale, index = 0, binLevel, prodInfo;
        for (let row of incoOrderProdStoreParsed) {
          info = row.info;
          status = row.status;
          prodOrderId = row.prodOrderId;
          binLevel = row.binLevel;
          totale = row.count;
          length = info.length;
          prodInfo = row.productName + ' / ' + row.chipName;
          if (status === storeStatus.received.val && prodOrderId === null && binLevelData && binLevelData.includes(binLevel)) {
            for (let i = 0; i < length; i++) {
              if (i === 0) {
                index++;
                this.unAssociatedBoxList.push({
                  prodInfo,
                  binLevel,
                  boxNo: row.boxNo,
                  ...info[i],
                  rowspan: length,
                  index,
                  totale,
                });
              } else {
                this.unAssociatedBoxList.push({
                  prodInfo,
                  binLevel,
                  boxNo: row.boxNo,
                  ...info[i],
                  totale,
                })
              }
            }
          }
        }
        this.visible = true;
      } catch (e) {
        // do nothing.
      }
    },
    scanBoxInfoBarCode() {
      let code = '';
      let nextCode;
      document.onkeypress = (e) => {
        nextCode = e.which;
        if (nextCode !== 13) {
          code += String.fromCharCode(nextCode);
        }
        if (nextCode === 13) {
          if (this.visible) {
          } else if (this.$refs.refProductOrderNo && this.$refs.refProductOrderNo.focused) {
          } else {
            this.form.productOrderNo = code;
            this.query();
          }
          code = '';
        }
      };
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex !== 3 && columnIndex !== 4) {
        if (row.rowspan) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
  }
  .el-form {
    text-align: center;
    margin: 10px auto 0;
  }
  .deliver-order-text {
    color: #1F232E;
    font-size: 17px;
    padding: 0 15px;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #DDDDDD;
    display: block;
    margin: 10px 0;
  }
  .title-container {
    box-sizing: border-box;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .title-text {
    color: #1F232E;
    font-size: 15px;
  }
</style>
